import { render, staticRenderFns } from "./HelpHowItWorks.vue?vue&type=template&id=bda7cf14&scoped=true"
import script from "./HelpHowItWorks.vue?vue&type=script&lang=ts"
export * from "./HelpHowItWorks.vue?vue&type=script&lang=ts"
import style0 from "./HelpHowItWorks.vue?vue&type=style&index=0&id=bda7cf14&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda7cf14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bda7cf14')) {
      api.createRecord('bda7cf14', component.options)
    } else {
      api.reload('bda7cf14', component.options)
    }
    module.hot.accept("./HelpHowItWorks.vue?vue&type=template&id=bda7cf14&scoped=true", function () {
      api.rerender('bda7cf14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Help/HelpHowItWorks.vue"
export default component.exports